export default "__VITE_ASSET__CURAu1vs__"